import type { RemoteFunction } from '#build/rpc-handler';
import { createClient, type RpcClientOptions } from 'nuxt-rpc/client';
import defu from 'defu';

// Client with default cache setting
export const rpc = (
  options?: RpcClientOptions): RemoteFunction => {
    return createClient<RemoteFunction>(
      defu(options, {
        apiRoute: '/api/__rpc',
        cache: false,
      })
    );
  }; 

  // Client with cache disabled
  export const rpcCacheless = rpc({ cache: false })
  

  // Client with cache enabled
  export const rpcCached = rpc({ cache: true })